<template>
  <div>
    <div v-if="loadingShow">
      <div class="gcloading">
        <img src="https://static.mingchu.co/webapp/images/components/animation_load.gif">
      </div>
    </div>
    <div class="scrollBox">
      <!-- 页面内容 -->
      <div class="r_1" />
      <div class="r_2">
        <a v-if="isGteatChefbrowser" href="https://m.mingchu.co/integralmall">查看积分可以兑换啥&gt;</a>
        <a v-else href="javascript:;">查看积分可以兑换啥&gt;</a>

      </div>
      <div class="cond">
        <div class="t" />
        <div class="cont">
          <div class="top">马上邀请好友</div>
          <ul class="list_share clearfix">
            <li @click="shareWx"><a href="javascript:;">微信</a></li>
            <li @click="sharewWxfriend"><a href="javascript:;">朋友圈</a></li>
            <li @click="shareImg"><a href="javascript:;">生成图片</a></li>
          </ul>
        </div>
        <div class="b" />
      </div>

      <div class="cond constent">
        <div class="t" />
        <div id="tabBox1" class="tabBox">
          <div class="hd">
            <ul class="clearfix">
              <li
                v-for="(item,i) in tabInfo"
                :key="i"
                :class="activeNum == i ? 'on' : ''"
                @click="activeNum=i"
              ><a href="javascript:void(0)">{{ item }}</a></li>
            </ul>
          </div>
          <div id="tabBox1-bd" class="bd">
            <div v-if="activeNum==0" class="con">
              <div class="pt30">
                <dl class="list_txt">
                  <dt>奖励规则</dt>
                  <dd>1. 成功邀请1名厨师下载注册名厨APP，获得200积分</dd>
                  <dd>2. 每日获得邀请奖励上限10次</dd>
                  <dd>3. 小七将为每月成功邀请厨师最多的用户送出名厨定制礼品一件</dd>
                  <dd>4. 被成功邀请的用户，将获得200积分+7天内发布菜品享积分3倍奖励</dd>
                  <dd>5. 本活动长期有效</dd>
                </dl>
                <dl class="list_txt">
                  <dt>活动说明</dt>
                  <dd>1. 名厨App注册⽤户，且拥有至少一个完整作品的用户，即可参与活动</dd>
                  <dd>2. 被邀请人需为厨师，且未注册过名厨App</dd>
                  <dd>3. 通过您的邀请链接或图片二维码成功注册的新用户视为有效邀请，双方均可获得相应积分奖励，可在“名厨APP——我的——积分中心”中查询</dd>
                  <dd>4. 积分不限使用时间，可用于名厨积分商城礼品兑换</dd>
                  <dd>5. 对于恶意刷取积分奖励的行为，将不予发放邀请奖励、追回相关奖励或封停账号</dd>
                  <dd>6. 名厨定制礼品将于每月榜单数据结算后统一安排寄送，请大家关注名厨APP站内通知消息</dd>
                  <dd>7. 名厨APP保留法律范围内允许的对活动的解释权</dd>
                </dl>
              </div>
            </div>
            <div v-else-if="activeNum==1" class="con">
              <div v-if="myInviteInfo.length>0">
                <div class="tip">
                  <template v-if="userInfo.invite_user_count">
                    已成功邀请{{ userInfo.invite_user_count }}人，获得{{ userInfo.invite_integral }}积分
                  </template>
                </div>
                <ul class="list_fr clearfix">
                  <li v-for="item in myInviteInfo" :key="item.uid">
                    <a :href="item.link" class="img_box"><img :src="item.usr_pic" alt=""></a>
                    <div class="name">{{ item.nick_name }}</div>
                    <div class="data">{{ item.register_time }}</div>
                  </li>
                </ul>
              </div>
              <div v-else style="margin-bottom:450px">
                <div class="zero" style="">邀请成功的好友会出现在这里<br>快去邀请吧</div>
                <div id="invite_tips" class="tip" style="display: none" />
                <ul id="invite_user_list" class="list_fr clearfix" style="display: none" />
              </div>
            </div>
            <div v-else class="con">
              <div>
                <div class="tip">
                  <template v-if="userInfo.invite_user_count">
                    已成功邀请{{ userInfo.invite_user_count }}人，排名第{{ userInfo.rankNum }}位
                  </template>
                </div>
                <ul class="list_bang clearfix">
                  <li v-for="(item,i) in inviteRank" :key="item.uid" class="dis_flex">
                    <a class="rank_img" :href="item.link">
                      <!-- <div class="img_box"> -->
                      <img :src="item.usr_pic" alt="">
                      <div class="fl_m">
                        <div class="names">{{ item.nick_name }}</div>
                        <!-- <div class="nums">已邀请<span>{{ item.invite_user_count }}</span>人</div> -->
                      </div>
                      <!-- </div> -->
                    </a>
                    <div class="bang">NO.{{ i+1 }}</div>
                  </li>
                </ul>
              </div>
            </div>

          </div>

        </div>
        <div class="b" />
      </div>
      <div class="foots"><span>名厨MINGCHU</span></div>
    </div>

    <div class="mask none" />
    <div class="alt a1 none">
      <div class="tp" />
      <div class="name" />
      <div class="txt">新人大礼包已放入您的名厨账户，请
        下载名厨APP并使用该手机号注册
        登录，查看礼包</div>
      <a href="javascript:;" class="btn">前往名厨APP查看</a>
      <a href="javascript:;" class="close" />
    </div>
    <div class="alt a2 none">
      <div class="oldf" />
      <div class="txt">none您可邀请好友加入名厨<br>
        每邀请成功一位，可得<span>200积分</span></div>
      <a href="javascript:;" class="btn">前往名厨APP邀请</a>
      <a href="javascript:;" class="close" />
    </div>
    <div v-show="isInviteShow" id="condition_mask" class="mask">
      <div id="invite_condition" class="g_hd_app ">
        <h3>您当前尚未满足邀请条件哦，<br>请至少发布一道真实完整作品</h3>
        <a id="close_btn" href="javascript:;" class="g_hd_close" @click="isInviteShow=false" />
        <div class="g_list_tel clearfix">
          <a id="ok" class="g_btn" @click="isInviteShow=false">好的</a>
          <a class="g_btn" href="https://m.mingchu.co/publish">去发布作品</a>
        </div>
      </div>
    </div>
    <input id="shareTitle" type="hidden" :value="shareInfo.shareTitle">
    <input id="shareDesc" type="hidden" :value="shareInfo.shareDesc">
    <input id="shareImg" type="hidden" :value="shareInfo.shareImg">
    <input id="shareLink" type="hidden" :value="shareInfo.shareLinkInput">
  </div>
</template>

<script>
// import { Navbar, TabItem, Indicator, InfiniteScroll, Toast } from 'mint-ui'
import { articles, ajaxHttp } from '@/api/api'
import utils from '@/utils/utils'
import config from '@/config/config'
import wx from 'weixin-js-sdk'

export default {
  data() {
    return {
      loading: true,
      loadingShow: true,
      isGteatChefbrowser: false,
      pathInfo: {},
      activeNum: 0,
      userInfo: {},
      myInviteInfo: [],
      inviteRank: [],
      tabInfo: [
        '活动规则',
        '我邀请的人',
        '邀请排行榜'
      ],
      shareInfo: {
        shareTitle: '送你一份名厨新手礼包，快来开启你的名厨之路吧！',
        shareDesc: '可用于兑换商品、申请产品试用等。上名厨，与烹饪艺术大师零距离！',
        shareImg: 'https://static.mingchu.co/m/images/weblogo.png',
        shareLinkInput: `${config.webapplink}/htmlPage/invite`,
        shareLink: `${config.webapplink}/htmlPage/inviteRegister`
      },
      isInviteShow: false,
      isLogin: false
    }
  },
  created() {
    /* eslint-disable */
    const self = this
    const dsType = dsBridge.call('openBackButton', 'test')
    const { query } = self.$route
    if (dsType == 1) { // app内
      self.isGteatChefbrowser = true
    }
    self.pathInfo = query
    self.shareLinkInput = `${config.webapplink}/htmlPage/invite`
    self.shareLink = `${config.webapplink}/htmlPage/inviteRegister`
  },
  mounted() {
    const self = this
    setTimeout(() => {
      self.getData()
    }, 1000)
  },
  methods: {
    getData() {
      const self = this
      Promise.all([
        self.getDataPromiss('/invite', {}, 'userInfo'),
        self.getDataPromiss('/invite/user', {}, 'myInviteInfo'),
        self.getDataPromiss('/invite/rank', {}, 'inviteRank')
      ]).then((res) => {
        this.shareInfo.shareLinkInput = `${self.shareInfo.shareLinkInput}?id=${self.userInfo.uid}`
        if (self.userInfo.uid != 0) self.isLogin = true
        self.$nextTick(() => {
          self.share(self.shareInfo)
          this.loadingShow = false
        })
        try {
          this.inviteRank.forEach((rankItem, i) => {
            console.log(rankItem.uid, self.userInfo.uid)
            if (rankItem.uid == self.userInfo.uid) {
              this.userInfo.rankNum = i + 1
              throw ('终止循环')
            } else {
              this.userInfo.rankNum = 0
            }
          })
        } catch (e) {}
        self.$forceUpdate()
      })
    },
    getDataPromiss($url, $data, $type) {
      return new Promise((resolve, reject) => {
        ajaxHttp.$get($url, $data).then(res => {
          if (res.code == 1) {
            this[$type] = res.data
            resolve(res.data)
          } else {}
        }).catch(err => {
          console.log(err)
        })
      })
    },
    share($shareInfo) {
      const self = this
      const share_url = escape(window.location.href)
      articles.share(share_url).then(res => {
        wx.config({
          debug: false,
          appId: res.appId, // 必填，公众号的唯一标识
          timestamp: res.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.nonceStr, // 必填，生成签名的随机串
          signature: res.signature, // 必填，签名，见附录1
          jsApiList: res.jsApiList
        })
        wx.ready(() => {
          const share_title = $shareInfo.shareTitle
          const share_desc = $shareInfo.shareDesc
          const share_link = $shareInfo.shareLink
          const share_img = $shareInfo.shareImg
          console.log('分享测试', share_link)

          wx.updateAppMessageShareData({
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: `${share_link}?id=${self.userInfo.uid}&referrer=share_wx`, // 分享链接
            imgUrl: share_img, // 分享图标
            success: function() {
              // 设置成功
					  }
          })
          wx.updateTimelineShareData({ // 分享给朋友
            title: share_title, // 分享标题
            desc: share_desc, // 分享描述
            link: `${share_link}?id=${self.userInfo.uid}&referrer=share_wx_circle`, // 分享链接
            imgUrl: share_img, // 分享图标
            success: function() {
              // 设置成功
					  }
          })
        })
      })
    },
    commonCheck() {
      let isJump = false
      const self = this
      if (self.isGteatChefbrowser) {
        if (self.userInfo.is_can_invite <= 0) {
          self.isInviteShow = true
          isJump = false
        } else {
          isJump = true
        }
      } else { isJump = false }
      return isJump
    },
    shareWx() {
      const self = this
      // const u = navigator.userAgent
      // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      // if (isAndroid) {
      const parms = `{
          "shareSDKPlatformType":"22", 
          "share_plant":"1", 
          "shareContentType":"0", 
          "share_miniProgram_url":"", 
          "share_title":"${self.shareInfo.shareTitle}",
          "share_desc":"${self.shareInfo.shareDesc}",
          "share_img": "${self.shareInfo.shareImg}", 
          "share_link": "${self.shareInfo.shareLink}?id=${self.userInfo.uid}&referrer=share_wx",  
          "share_desc_Sinaweibo":""
          }`
      self.commonCheck() && dsBridge.call('js_callNativeShareSDK', parms, function(result) {})
      // } else {
      //   self.commonCheck() && dsBridge.call('shareWX', {
      //     'imgurl': self.shareInfo.shareImg,
      //     'link': `${self.shareInfo.shareLink}?id=${self.userInfo.uid}&referrer=share_wx`,
      //     'title': self.shareInfo.shareTitle,
      //     'desc': self.shareInfo.shareDesc })
      // }
    },
    sharewWxfriend() {
      const self = this
      // const u = navigator.userAgent
      // const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
      // if (isAndroid) {
      const parms = `{
          "shareSDKPlatformType":"23", 
          "share_plant":"1", 
          "shareContentType":"0", 
          "share_miniProgram_url":"", 
          "share_title":"${self.shareInfo.shareTitle}",
          "share_desc":"${self.shareInfo.shareDesc}",
          "share_img": "${self.shareInfo.shareImg}", 
          "share_link": "${self.shareInfo.shareLink}?id=${self.userInfo.uid}&referrer=share_wx",  
          "share_desc_Sinaweibo":""
        }`
      self.commonCheck() && dsBridge.call('js_callNativeShareSDK', parms, function(result) {})
      // } else {
      //   self.commonCheck() && dsBridge.call('shareWXCircle', {
      //     'imgurl': self.shareInfo.shareImg,
      //     'link': `${self.shareInfo.shareLink}?id=${self.userInfo.uid}&referrer=share_wx_circle`,
      //     'title': self.shareInfo.shareTitle,
      //     'desc': self.shareInfo.shareDesc })
      // }
    },
    shareImg() {
      const self = this
      self.commonCheck() &&
          dsBridge.call('shareImage',
            { 'backGroundImg': self.userInfo.back_ground_img,
              'headImg': self.userInfo.usr_pic,
              'nickName': self.userInfo.nick_name,
              'QRCodeLink': `${self.shareInfo.shareLink}?id=${self.userInfo.uid}&referrer=share_img`,
              'headerImg': self.userInfo.usr_pic,
              'qrLink': `${self.shareInfo.shareLink}?id=${self.userInfo.uid}&referrer=share_img`
            })
    },
    shareBtn() {
      if (this.isGteatChefbrowser) {
        // 是否是名厨浏览器
        utils.showShare()
      } else {
        // this.share();
        console.log('微信环境')
      }
    }

  }
}
</script>

<style lang="scss" scoped>
  @import url('https://static.mingchu.co/invite/styles/styles.css');
  @import url('https://static.mingchu.co/invite/styles/styles_1.css');

  .constent{ overflow:hidden;}
  .mask{ opacity: 1 !important; background: rgba(0,0,0,0.7) !important; }
  .tabBox .bd .list_bang .fl_m{padding-top: 1.3rem;}
  .tabBox .bd .list_bang .img_box{margin-top: 0;}
  .tabBox .bd .list_bang .bang{margin-top: 0;}
  .tabBox .bd .list_bang .fl_m{padding-top: 0;}
  .img_box{display: flex; align-items: center;}
  .rank_img{
    display: flex;
    align-items: center;
img {
    width: 3.22rem;
    height: 3.22rem;
    border-radius: 50%;
    }
  }
  .dis_flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
.gcloading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 999;
	img{
		width: 375px;
		position: absolute;
		top: 30vh;
		left: 50%;
    transform: translateX(-50%);
	}
}
.foots{
  width: 100%;
  height: 240px;
  background:#ff671f;
  text-align: center;
  font-size: 36px;
  line-height: 220px;
}
.foots span{z-index: 999;color:#fff;font-size: 36px;}
</style>
